import React, { MouseEventHandler } from 'react';
import './CloseButton.scss';

interface CloseButtonProps {
  onClick: MouseEventHandler<HTMLElement>;
  className?: string;
}

export const CloseButton = ({ onClick, className }: CloseButtonProps) => {
  return (
    <i
      onClick={onClick}
      className={
        'c-close-button icon-symbol-close' + (className === 'search-close' ? ' search-close' : '')
      }
    />
  );
};
